import React, { useEffect, useState } from 'react';
import Header, { HeaderLeft, HeaderRight } from '../../layout/Header/Header';
import tempImage from '../../assets/bg.png';
import Avatar from '../../components/Avatar';
import Button from '../../components/bootstrap/Button';
import User from '../../layout/User/User';
import Input from '../../components/bootstrap/forms/Input';
import 'remixicon/fonts/remixicon.css';
import { useMst } from '../../models';
import Logo from '../../components/Logo';
import { Link } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import Popovers from '../../components/bootstrap/Popovers';
import { observer } from 'mobx-react';
import Badge from '../../components/bootstrap/Badge';

const UserDefaultHeader = observer(() => {
	const [roleNames, setRoleNames] = useState([])
	const { user } = useMst();
	
	useEffect(() => {
		if (user.me) setRoleNames(user.me.type)
	}, [user.me])

	return (
		<Header>
			{/* <HeaderLeft>&nbsp; */}
			<HeaderLeft className={'d-flex flex-row align-items-center'}>
				{/* <h1 className='brand-head'>
					<Link to='/' aria-label='Logo' alt='CCP'>
						<Logo width={'100%'} />
					</Link>
				</h1> */}
				<div className='d-flex'>
					<div>
						<Badge color='info'>{user.me?.isAdmin ? '최고관리자' : user.me?.type  || '권한이 없습니다'}</Badge>
					</div>
					{user.me?.userSystems && roleNames.length > 0 ? (
						<Popovers
							trigger='hover'
							placement={'bottom'}
							desc={
								<div className='d-flex flex-column'>
									{roleNames?.map((r) => (
										<div key={r.usergroupname} className='type-zone'>
											<span className='type-zone-badge'>{r.usergroupname} </span> <span> {r.usergroupcode} </span>
										</div>
									))}
								</div>
							}>

						</Popovers>
					) : null}
				</div>
			</HeaderLeft>
			<HeaderRight>
				<div className=''>
					<div className='w-auto d-flex flex-row align-items-center'>
						{/* <div className='page-title'></div> */}
						{/* <span>{user?.me?.userType === 'ADMIN' ? '관리자' : '사용자'}</span> */}
						<User className='mt-2' />
					</div>
				</div>
				{/* <div className='page-title'> </div> */}
				{/* <Button icon='Settings' aria-label='Settings' />
				<Button icon='Notifications' aria-label='Notifications' />
				<Avatar
					rounded={'circle'}
					size={35}
					className={'border'}
					name={''}
					src={tempImage}
				/> */}
			</HeaderRight>
		</Header>
	);
});

export default UserDefaultHeader;
